import { gql } from '@apollo/client';

import client from '../../../config/apolloClient';
import { IFilter, IPage, constructUrlWithParams } from '../../../utils/sortFilterFramework';
import URL from '../../../constants/ApiEndPoints';

const GET_SEARCH_CUSTOMER_LIST = gql`
  query getSearchCustomerList($path: String!) {
    getSearchCustomerList @rest(method: "GET", path: $path, endpoint: "pheonix") {
        data
        pageInfo
      }
  }
`;

const getSearchCustomerListService = (filter?: IFilter[], page?: IPage) => {
  const url = constructUrlWithParams(URL.getSearchCustomerList, filter, undefined, page);
  return client.query({ query: GET_SEARCH_CUSTOMER_LIST, variables: { path: url } });
};

export default getSearchCustomerListService;
